import {GET_REPORT_COMPANIES_ERROR, GET_REPORT_COMPANIES_REQUEST, GET_REPORT_COMPANIES_SUCCESS} from "../constants/reportCompanies";
import {IActionReportCompanies} from "../actions/reportCompanies";
import {IReportCompany} from "../../models/Report";


export interface IReportCompaniesState {
    loading: boolean
    error: string
    data: IReportCompany[]
    total: number
    by: number
}

const initialState: IReportCompaniesState = {
    data: [],
    loading: false,
    error: '',
    total: 0,
    by: 0
};

export default function reportCompanies(state = initialState, action: IActionReportCompanies): IReportCompaniesState {
    switch (action.type) {
        case GET_REPORT_COMPANIES_REQUEST:
            return {
                data: [],
                loading: true,
                error: '',
                total: 0,
                by: 0
            };
        case GET_REPORT_COMPANIES_SUCCESS:
            const {data, total, by} = action.payload;
            return {
                data,
                loading: false,
                error: '',
                total,
                by
            };
        case GET_REPORT_COMPANIES_ERROR:
            return {
                data: [],
                loading: false,
                error: action.payload,
                total: 0,
                by: 0
            };
        default:
            return state;
    }
}
